module.exports = __webpack_public_path__ + "static/img/平台_图2@2x.fae9d4cc.png";